var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXandrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 35,
    viewBox: "0 0 163 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5315 33.2121L43.8762 26.0451L38.1733 33.2209C37.8808 33.6024 37.502 33.9117 37.0668 34.1247C36.6315 34.3376 36.1519 34.4483 35.6656 34.4479H30.5928L40.6038 21.9085L31.0261 9.36914H36.1498C37.1354 9.36914 38.0633 9.82249 38.6543 10.5922L44.0205 17.8733L49.3866 10.5922C49.6791 10.2119 50.0575 9.90353 50.4921 9.69129C50.9266 9.47905 51.4053 9.36878 51.8907 9.36914H56.8221L47.197 21.9124L57.2551 34.4479H52.0461C51.5579 34.4484 51.0763 34.337 50.6397 34.1225C50.2032 33.9079 49.8236 33.5962 49.5315 33.2121Z",
    fill: "#211F1F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 8,
    width: 28,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5742 8.95703H82.7095V34.7247H55.5742V8.95703Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6552 27.5175C76.0936 26.0729 76.8123 24.1724 76.8123 21.8172C76.8123 19.4617 76.0938 17.5623 74.6552 16.1174C73.2168 14.6733 71.3954 13.9502 69.19 13.9502C66.984 13.9502 65.1699 14.6733 63.748 16.1174C62.326 17.5623 61.6151 19.4617 61.6151 21.8172C61.6151 24.1724 62.326 26.0729 63.748 27.5175C65.1699 28.9619 66.984 29.6845 69.19 29.6845C71.3954 29.6845 73.2168 28.9619 74.6552 27.5175ZM82.7095 9.23951V34.3949H80.1204C78.3994 34.3949 77.0046 33.0241 77.0046 31.3333V31.1445C76.0133 32.339 74.7902 33.2335 73.3364 33.8296C71.8829 34.4257 70.2764 34.7247 68.5186 34.7247C66.0261 34.7247 63.7972 34.1912 61.8314 33.1227C59.8652 32.0562 58.3314 30.5487 57.2287 28.6006C56.1257 26.6538 55.5742 24.3929 55.5742 21.8172C55.5742 19.2426 56.1257 16.9886 57.2287 15.057C58.3311 13.1264 59.8649 11.6258 61.8312 10.5582C63.7969 9.49113 66.0259 8.95703 68.5181 8.95703C70.1798 8.95703 71.7063 9.23951 73.0967 9.80447C74.4865 10.37 75.6933 11.2028 76.7166 12.3013C76.7166 10.6103 78.1115 9.23951 79.8325 9.23951H82.7092H82.7095Z",
    fill: "#211F1F"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.614 11.8935C111.566 13.7609 112.543 16.5289 112.543 20.1995V34.7237H109.662C107.938 34.7237 106.54 33.343 106.54 31.6387V20.9596C106.54 18.7447 106.012 17.0751 104.956 15.9521C103.899 14.8293 102.394 14.2666 100.442 14.2666C98.2326 14.2666 96.4875 14.9241 95.2074 16.2371C93.9259 17.55 93.2866 19.4402 93.2866 21.9087V31.6387C93.2866 33.343 91.8889 34.7237 90.1648 34.7237H87.2842V9.37816H89.8772C91.6007 9.37816 92.9981 10.7591 92.9981 12.4631V12.653C93.9907 11.4823 95.2385 10.5963 96.744 9.99521C98.2483 9.39387 99.9446 9.09375 101.835 9.09375C105.068 9.09375 107.66 10.0272 109.614 11.8935Z",
    fill: "#211F1F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 0,
    width: 28,
    height: 35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.571 0.101562H142.748V34.9996H115.571V0.101562Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.114 28.979C134.264 28.3336 135.175 27.4129 135.846 26.2162C136.517 25.0205 136.853 23.6359 136.853 22.0609C136.853 20.4873 136.517 19.1024 135.846 17.9058C135.175 16.7095 134.264 15.7893 133.114 15.143C131.963 14.4981 130.669 14.1754 129.231 14.1754C127.794 14.1754 126.5 14.4979 125.349 15.1427C124.198 15.789 123.288 16.7095 122.617 17.9058C121.946 19.1024 121.61 20.4875 121.61 22.0609C121.61 23.6359 121.946 25.0207 122.617 26.2162C123.288 27.4129 124.198 28.3336 125.349 28.979C126.5 29.6248 127.794 29.9469 129.231 29.9469C130.669 29.9469 131.963 29.6248 133.114 28.979ZM142.748 0.101562V34.6689H140.112C138.391 34.6689 136.997 33.2951 136.997 31.5996V31.4106C136.005 32.6077 134.783 33.5048 133.33 34.1025C131.875 34.6992 130.269 34.9996 128.512 34.9996C126.051 34.9996 123.839 34.4647 121.874 33.3943C119.909 32.325 118.367 30.8054 117.249 28.8371C116.13 26.8697 115.571 24.6109 115.571 22.0609C115.571 19.5111 116.13 17.2607 117.249 15.3081C118.367 13.3575 119.909 11.8459 121.874 10.7755C123.839 9.70562 126.051 9.16987 128.512 9.16987C130.206 9.16987 131.755 9.45318 133.162 10.0198C134.568 10.5864 135.766 11.4366 136.757 12.5696V0.101838H142.748V0.101562Z",
    fill: "#211F1F"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.5 9.09375V14.7414C161.986 14.6466 161.521 14.5989 161.103 14.5989C158.76 14.5989 156.931 15.2714 155.616 16.6163C154.3 17.9617 153.642 19.8997 153.642 22.4307V31.639C153.642 33.343 152.241 34.7237 150.513 34.7237H147.625V9.37871H153.353V13.0799C155.086 10.4226 158.135 9.09375 162.5 9.09375Z",
    fill: "#211F1F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 13,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4268H12.9416V21.3462H0V10.4268Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54154 10.4268C6.3272 10.6323 6.14266 10.8658 5.99313 11.1207L0 21.3462H12.9416L6.54154 10.4268Z",
    fill: "#E10500"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7686 9.49055C20.4783 9.41058 20.1782 9.37006 19.8767 9.37012H8.75032C8.44441 9.37012 8.14495 9.41146 7.8584 9.49055L14.3135 20.3937L20.7686 9.49055Z",
    fill: "#F73232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.874L5.97854 33.1971C6.1301 33.4581 6.31477 33.6929 6.52582 33.8976L12.9102 22.874H0Z",
    fill: "#FC5047"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6484 33.1971L28.627 22.874H15.7168L22.1017 33.8976C22.3157 33.6898 22.4997 33.4541 22.6484 33.1971Z",
    fill: "#FF7061"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8584 34.6034C8.14495 34.6825 8.44469 34.7238 8.75032 34.7238H19.8767C20.1826 34.7238 20.482 34.6825 20.7686 34.6034L14.3135 23.7002L7.8584 34.6034Z",
    fill: "#FC8D7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.627 21.2199L22.6484 10.8968C22.4994 10.6399 22.3153 10.4042 22.1012 10.1963L15.7168 21.2199H28.627Z",
    fill: "#FC5047"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.5,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXandrLogo);
export default __webpack_public_path__ + "static/media/xandr-logo.9fecc0426ed94f627b02dcddb7b33189.svg";
export { ForwardRef as ReactComponent };